module.exports = __webpack_public_path__ + "assets/img/closed.471d25d9.png";